// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2c-S6","inputWrap":"styles_inputWrap__XgYc8","input":"styles_input__2trKZ"};